import React from 'react';
import { CircularProgress, Grid } from '@mui/material';
import { useStyles } from './styles';
import clsx from 'clsx';
import { LogoExtended } from '../../icons/common';

type Props = {
  fullScreen?: boolean;
  className?: string;
  size?: number;
  centred?: boolean;
  rootClassName?: string;
  showLogoExtended?: boolean;
};

const CentredCircularProgress = (props: Props) => {
  const { classes } = useStyles();
  const progressClass = clsx(classes.progress, props.className);
  const fullScreenClass = props.showLogoExtended
    ? classes.logoExtended
    : classes.fullScreen;

  const renderLogo = () => {
    if (!props.showLogoExtended) {
      return <CircularProgress className={progressClass} size={props.size} />;
    } else {
      return <LogoExtended />;
    }
  };
  if (!props.centred) {
    renderLogo();
  }

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={props.fullScreen ? fullScreenClass : props.rootClassName}
    >
      {renderLogo()}
    </Grid>
  );
};

export default CentredCircularProgress;
